// 懒加载
// 处理图片懒加载
const lazyImages = document.querySelectorAll("img[data-src]");
const imgObserver = new IntersectionObserver((entries, observer) => {
    entries.forEach(entry => {
        if (entry.isIntersecting) {
            const img = entry.target;
            img.src = img.dataset.src;
            img.removeAttribute("data-src");
            observer.unobserve(img);
        }
    });
}, {
    rootMargin: '0px 0px 600px 0px'
});

lazyImages.forEach(img => {
    imgObserver.observe(img);
});

// 处理视频懒加载
// 获取所有懒加载的视频
const lazyVideos = document.querySelectorAll("video");

// 创建 IntersectionObserver
const videoObserver = new IntersectionObserver(
  (entries, observer) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        const video = entry.target; // 获取当前 video
        const sources = video.querySelectorAll("source[data-src]"); // 获取 video 内所有的 source

        // 为每个 source 设置 src
        sources.forEach((source) => {
          const sourceSrc = source.dataset.src;
          if (sourceSrc) {
            source.src = sourceSrc; // 将 data-src 设置为 src
            source.removeAttribute("data-src");
          }
        });

        const videoSrc = video.dataset.src; // 检查 video 的 data-src
        if (videoSrc) {
          video.src = videoSrc; // 为 video 设置 src
          video.removeAttribute("data-src");
        }

        video.load(); // 加载视频
        // video.play().catch((err) => console.log("Video play error:", err)); 

        observer.unobserve(video); // 停止观察
      }
    });
  },
  {
    rootMargin: "0px 0px 600px 0px", // 提前加载区域
  }
);

// 为每个视频绑定观察器
lazyVideos.forEach((video) => {
  videoObserver.observe(video);
});
